// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".code-wrapper[data-v-4c8a4d8c] {\n  position: relative;\n  background: #E8EEF1;\n}\n.copy-btn[data-v-4c8a4d8c] {\n  position: absolute;\n  right: 4px;\n  top: 50%;\n  margin-top: -14px;\n}", ""]);
// Exports
module.exports = exports;
